import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <AboutSection />
        <FeaturesSection />
        <MediaSection />
        <FaqSection />
        <TopicsSection />
        <CardsSection />
        <IndexSection />
        <CarouselSection />
        <AppSection />
        <CommentsSection />
        <RankingSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}